import { TLoginResponse } from '../types';
import {
  ACCESS_TOKEN_KEY,
  QUERY_EXPIRATION_KEY,
  QUERY_TOKEN_KEY
} from '../utils/constants';
import { parseQuery } from '../utils/parseQuery';

const setToken = (TokenData: TLoginResponse) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(TokenData));
};

const clearToken = () => {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
};

const getToken = () => {
  let tokenData: TLoginResponse = undefined;
  const query = parseQuery(window.location.search);
  const tokenOverride = query[QUERY_TOKEN_KEY];
  const expiresInOverride =
    query[QUERY_EXPIRATION_KEY] ||
    new Date(
      Date.now() + 3600 * 1000 * 24 // 1 day
    ).toISOString();

  try {
    if (tokenOverride) {
      tokenData = {
        token: tokenOverride,
        expiresIn: expiresInOverride,
        isSandbox: true
      };
      setToken(tokenData);
    } else {
      const storedToken = JSON.parse(localStorage.getItem(ACCESS_TOKEN_KEY));

      const isInternalRedirectOrReload =
        document.referrer && document.referrer.includes(window.location.origin);

      if (!storedToken?.isSandbox || isInternalRedirectOrReload) {
        tokenData = storedToken;
      }
    }
  } catch (e) {
    console.error(e);

    return undefined;
  }

  return tokenData;
};

export const checkIsExpired = (loginData: TLoginResponse) => {
  if (!loginData || !loginData.token) {
    return true;
  }

  const expiredDate = loginData.expiresIn;

  return new Date(expiredDate) < new Date();
};

export const tokenStore = () => ({
  setToken,
  getToken,
  clearToken,
  checkIsExpired
});
